export const extractSectionHtmlById = (fullHtml, sectionId) => {
  if (!fullHtml || !sectionId) return " ";

  const parser = new window.DOMParser();
  const doc = parser.parseFromString(fullHtml, "text/html");
  const sectionDiv = doc.querySelector(`div[data-section-id="${sectionId}"]`);

  return sectionDiv ? sectionDiv.innerHTML : " ";
};
